import { render, staticRenderFns } from "./BotClientDetails.vue?vue&type=template&id=c56f538c&"
import script from "./BotClientDetails.vue?vue&type=script&lang=js&"
export * from "./BotClientDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports